"use client";

import { useQuery } from "@tanstack/react-query";
import { useApi } from "@/lib/hooks/use-api";
import { queryKeys } from "@/lib/query-keys";

export const usePlatformStats = () => {
  const api = useApi();
  return useQuery({
    queryKey: queryKeys.platform.stats(),
    queryFn: async () => {
      const res = await api.platform.getStats();
      return res?.data ?? null;
    },
    // Dashboard stats can be slightly stale.
    staleTime: 60 * 1000,
  });
};
